// Now let's create a hook to use toasts throughout the application
// src/features/toast/useToast.ts

import { useDispatch } from "react-redux";
import {
  showToast as showToastAction,
  ToastType,
} from "../../Redux/Slices/ToastSlice";

export const useToast = () => {
  const dispatch = useDispatch();

  const showToast = (
    message: string,
    type: ToastType = "info",
    duration?: number,
  ) => {
    dispatch(showToastAction({ message, type, duration }));
  };

  return {
    showToast,
    success: (message: string, duration?: number) =>
      showToast(message, "success", duration),
    error: (message: string, duration?: number) =>
      showToast(message, "error", duration),
    info: (message: string, duration?: number) =>
      showToast(message, "info", duration),
    warning: (message: string, duration?: number) =>
      showToast(message, "warning", duration),
  };
};
